import { render, staticRenderFns } from "./ScrapingService.vue?vue&type=template&id=f67550d2&scoped=true&"
import script from "./ScrapingService.vue?vue&type=script&lang=js&"
export * from "./ScrapingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67550d2",
  null
  
)

export default component.exports